import { Loader2Icon } from 'lucide-react'

import { cn } from '@/utils'

interface LoaderProps {
  className?: string
  size?: 'sm' | 'md' | 'xl'
}

export const Loader = ({ className, size = 'sm' }: LoaderProps) => (
  <Loader2Icon
    className={cn(
      'animate-spin',
      size === 'xl' && 'size-20',
      size === 'md' && 'size-6',
      size === 'sm' && 'size-3',
      className,
    )}
  />
)
